export enum RouteNames {
  Cameras = 'Cameras',
  CameraSetup = 'CameraSetup'
}
